/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SubmittingInputs */

const et_contact_submitting = /** @type {(inputs: Contact_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saadan...`)
};

const en_contact_submitting = /** @type {(inputs: Contact_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending...`)
};

/**
* | output |
* | --- |
* | "Sending..." |
*
* @param {Contact_SubmittingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_submitting = /** @type {((inputs?: Contact_SubmittingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SubmittingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_submitting(inputs)
	return en_contact_submitting(inputs)
});